import update from 'immutability-helper'
import { normalizeResponseData, processError } from './error'

// bindable: These are all expected to bind to a Component class
export function setStateForErrorResponse(rawResponse = null, asToast = false) {
  const response = rawResponse && processError(rawResponse)
  this.setState({
    error: response && response.data ? normalizeResponseData(response.data) : null
  })
}

export function setStateForNewToast({ title, message, type = null, timeout = 1000 * 10 }) {
  const toast = {
    id: Math.random().toString(36).substring(7),
    title,
    message,
    type,
    date: new Date(),
    timeout
  }
  this.setState({
    toasts: update(this.state.toasts, { $push: [toast] })
  })
}
export function setStateToRemoveToast(id) {
  const { toasts } = this.state
  const toastIndex = toasts.findIndex((toast) => toast.id === id)
  this.setState({
    toasts: update(this.state.toasts, { $splice: [[toastIndex, 1]] })
  })
}
// bindable: end
